export const authCookieName = 'kaluza-platform:auth-token';
export const rolesCookieName = 'kaluza-platform:roles';
export const permissionsCookieName = 'kaluza-platform:permissions';
export const providerCookieName = 'kaluza-platform:provider';
export const organisationsCookieName = 'kaluza-platform:organisations';
